import Router from 'next/router';
import { useEffect } from 'react';

const paramsToRemove = ['utm_term', 'zip'];

export default function useRemoveQueryParams() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const allParams = [...url.searchParams.keys()];

    allParams.forEach(param => {
      if (paramsToRemove.includes(param)) {
        url.searchParams.delete(param);
      }
    });

    if (window.location.href !== url.toString()) {
      const { query } = Router;

      // Update Next.js' query object to match the URL's search params
      [...new URL(window.location.href).searchParams.keys()].forEach(key => {
        if (!url.searchParams.has(key)) {
          delete query[key];
        }
      });

      void Router.push({ pathname: Router.pathname, query }, url, {
        shallow: true,
        scroll: false
      });
    }
  }, []);
}
